import React from 'react';
import TopBar from '@/components/landing/TopBar';
import Hero from '@/components/landing/Hero';
import Stats from '@/components/landing/Stats';
import About from '@/components/landing/About';
import Areas from '@/components/landing/Areas';
import Testimonials from '@/components/landing/Testimonials';
import ContactForm from '@/components/landing/ContactForm';
import Footer from '@/components/landing/Footer';
import StickyMobileCTA from '@/components/landing/StickyMobileCTA';

const LandingPage = () => {
  return (
    <main className="min-h-screen bg-white font-sans">
      <TopBar />
      <Hero />
      <Stats />
      <About />
      <Areas />
      <Testimonials />
      <ContactForm />
      <Footer />
      <StickyMobileCTA />
    </main>
  );
};

export default LandingPage;
